import { List } from 'immutable';

export const waitlistEventFull = (event, tickets = List()) => {
  const ticketsNoCapacity = tickets.every((ticket) => ticket.get('available_quantity') === 0);
  return ticketsNoCapacity && event.get('enable_waitlist') && event.get('waitlist_trigger_event_capacity');
};

export const waitlistTicketSoldout = (event, ticket) => {
  const ticketSoldout = ticket.get('available_quantity') === 0;
  return ticketSoldout && event.get('enable_waitlist') && event.get('waitlist_trigger_tickets_sold_out');
};
